
const getImageUrl = (url, height = 600) => {
    if (url != undefined && url != '') {
        return url;
    }
    return `https://placeholder.pics/svg/${ Math.round(height*1.333)}x${height}`;
}

const formatDate = (date) => {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${month}/${day}/${year}`
};

const parseDate = (date) => {
    if (!date) return null

    const [month, day, year] = date.split('/')
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export {
    getImageUrl,
    formatDate,
    parseDate,
}